<ng-container *transloco="let t">
  <ld-base-modal
    [title]="t('modalsRequestCallbackTitle')"
    [size]="'medium'"
    [isLoading]="isLoading()"
    [ariaLabelledBy]="'request-callback-modal-title'"
    (closeModal)="onCancel()"
  >
    <div modal-content>
      <p class="font-dm text-sm text-ld-neutral-500 mb-4">{{ t('modalsRequestCallbackSubtitle') }}</p>

      @for (agent of agents(); track agent.id; let i = $index) {
        <button
          [id]="'agent-option-' + i"
          type="button"
          class="w-full flex items-center gap-3 p-3 rounded-xl cursor-pointer transition-colors mb-2 last:mb-0"
          [class.border-2]="selectedAgent() === agent"
          [class.border-ld-primary]="selectedAgent() === agent"
          [class.hover:bg-ld-neutral-50]="selectedAgent() !== agent"
          [class.border]="selectedAgent() !== agent"
          [class.border-ld-neutral-200]="selectedAgent() !== agent"
          (click)="selectAgent(agent)"
          [disabled]="isLoading()"
        >
          <div
            class="w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0"
            [class.border-ld-primary]="selectedAgent() === agent"
            [class.bg-ld-primary]="selectedAgent() === agent"
            [class.border-ld-neutral-300]="selectedAgent() !== agent"
          >
            @if (selectedAgent() === agent) {
              <mat-icon class="text-white text-sm! w-3! h-3!">check</mat-icon>
            }
          </div>

          <div class="size-10 rounded-full bg-ld-neutral-200 flex items-center justify-center overflow-hidden shrink-0">
            @if (agent.avatarUrl) {
              <img [src]="agent.avatarUrl" [alt]="agent.name" class="size-full object-cover" />
            } @else {
              <span class="font-dm font-medium text-ld-neutral text-sm">
                {{ getInitials(agent.name) }}
              </span>
            }
          </div>

          <div class="flex-1 text-left">
            <p class="font-dm font-medium text-base text-ld-neutral">{{ agent.name }}</p>
            <p class="font-dm text-sm text-ld-neutral-500">{{ agent.roleDisplayName }}</p>
          </div>
        </button>
      }
      @if (agents().length === 0) {
        <div class="text-center py-8">
          <mat-icon class="text-ld-neutral-200 text-4xl! w-10! h-10! mb-2">people</mat-icon>
          <p class="font-dm text-sm text-ld-neutral-500">{{ t('modalsRequestCallbackNoTeamMembers') }}</p>
        </div>
      }
    </div>

    <div modal-footer>
      <button
        id="request-callback-cancel-btn"
        type="button"
        class="btn-outline-ld-purple"
        [disabled]="isLoading()"
        (click)="onCancel()"
      >
        {{ t('commonButtonsCancel') }}
      </button>
      <button
        id="request-callback-confirm-btn"
        type="button"
        class="btn-primary-ld-purple"
        [disabled]="isLoading() || !selectedAgent()"
        (click)="onConfirm()"
      >
        @if (isLoading()) {
          <mat-spinner diameter="16" class="w-4! h-4!"></mat-spinner>
        }
        {{ t('modalsRequestCallbackConfirmButton') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
